import {
  faAngleDown,
  faCompass,
  faHouse,
  faKey,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import constants from "../constants/constants";
import SEO, { pageSEO } from "../components/seo.component";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../functions/animations";


export default function BuyerGuide() {

  const [open, setOpen] = useState(
    new Array(constants.BUYING_GUIDE.length).fill(false)
  );

  const seoConfig = pageSEO.buyerGuide();


  const toggleAccordion = (index) => {

    const temp = [...open];

    temp[index] = !temp[index];

    setOpen(temp);

  };


  return (

    <>
      <SEO {...seoConfig} />

      {/* HERO */}
      <section className="relative overflow-hidden bg-cottage-secondary pt-40 pb-28">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true
          }}
          className="relative mx-auto max-w-6xl px-6 text-center">

          <motion.p
            variants={fadeUp}
            className="uppercase tracking-[0.5em] font-semibold text-cottage-accent"
          >
            Home Buying Journey
          </motion.p>

          <motion.h1
            variants={fadeUp}
            className=" mt-6 font-serif text-5xl leading-none text-cottage-primary lg:text-7xl"
          >
            Your Guide To
            <br />
            Finding Home
          </motion.h1>

          <motion.p
            variants={fadeUp}
            className="mx-auto mt-8 max-w-3xl text-lg leading-8 text-cottage-muted"
          >
            Navigate every step of your buying journey with confidence.
            From understanding the market to receiving the keys,
            get expert guidance throughout the process.
          </motion.p>
        </motion.div>
      </section>

      {/* CONTENT */}
      <section className="mx-auto max-w-[1400px] px-6 py-24">
        <div className="grid gap-12 lg:grid-cols-[320px_1fr]">
          {/* SIDE CARD */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true
            }}
            className="hidden lg:block"
          >
            <div className=" sticky top-32 rounded-[40px] bg-cottage-primary p-10 text-white">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-cottage-accent/20">
                <FontAwesomeIcon
                  icon={faCompass}
                  className="text-3xl text-cottage-highlight"
                />
              </div>

              <h3 className="mt-8 font-heading text-4xl">
                Start Your
                <br />
                Journey
              </h3>

              <p className="mt-5 leading-7 text-white/70">
                Follow each step carefully and make confident decisions
                with professional guidance.
              </p>

              <div className="mt-10 space-y-5 text-sm uppercase tracking-widest">
                <div className="flex items-center gap-4">
                  <FontAwesomeIcon
                    icon={faHouse}
                    className="text-cottage-highlight"
                  />
                  Find Your Home
                </div>

                <div className="flex items-center gap-4">
                  <FontAwesomeIcon
                    icon={faKey}
                    className="text-cottage-highlight"
                  />
                  Get The Keys
                </div>
              </div>
            </div>
          </motion.div>

          {/* ACCORDION */}
          <div className="space-y-5">
            {
              constants.BUYING_GUIDE.map((guide, index) => (
                <motion.div
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{
                    once: true
                  }}
                  key={index}
                  className="overflow-hidden rounded-[32px] border border-cottage-border bg-white shadow-sm transition-all  hover:shadow-xl"
                >
                  <button
                    onClick={() =>
                      toggleAccordion(index)
                    }
                    className="group flex w-full items-center justify-between px-7 py-7 text-left md:px-10"
                  >
                    <div className="flex items-center gap-6">
                      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-cottage-secondary text-cottage-primary font-semibold">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h2 className="font-heading text-3xl text-cottage-primary transition group-hover:text-cottage-accent">
                        {guide.heading}
                      </h2>
                    </div>

                    <FontAwesomeIcon
                      icon={faAngleDown}
                      className={`text-cottage-accent transition-transform duration-300
                      ${open[index]
                          ?
                          "rotate-180"
                          :
                          ""
                        }
                    `}
                    />
                  </button>

                  <div
                    className={`grid transition-all duration-500 ease-in-out
                  ${open[index]
                        ?
                        "grid-rows-[1fr]"
                        :
                        "grid-rows-[0fr]"
                      }
                  `}
                  >
                    <div className="overflow-hidden">
                      <div className="border-t border-cottage-border px-7 pb-8 pt-6 leading-8 text-cottage-muted md:px-10">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: guide.text
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))
            }
          </div>

        </div>
      </section>
    </>
  );

}